import { Injectable } from '@angular/core';
import { Adapter } from '../interfaces/adapter';

export class SupoType {
  id: number;
  createdOn: Date | null;
  code: string;
  name: string;

  public constructor(init?: Partial<SupoType>) {
    Object.assign(this, init);
  }
}

@Injectable({
  providedIn: 'root'
})
export class SupoTypeAdapter implements Adapter<SupoType> {
  constructor() {}

  adapt(item: any): SupoType {
    return new SupoType({
      id: item.id,
      createdOn: item.createdOn === '' ? null : new Date(item.createdOn),
      code: item.code,
      name: item.name
    });
  }
}
